import React, { Component } from 'react'
import moment from 'moment';
import axios from 'axios';
import { APIURL } from '../../hoc/AxiosSetting/axios';


export default class ViewofCertificationStatus extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: props.match.params.id,
            data: {},
            isLoading: false
        }
    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.id || 0 };
    }
    componentDidMount() {
        axios.get(APIURL + '/api/othercertstatus/get/othercertificatedetailsview/' + this.state.id)
            .then(res => {
                if (res.data.errorCode === 0) {
                    this.setState({ data: res.data.response})
                    console.log("res.data.response 19", res.data.response)
                }
            })

    }

   handleRoute = () => {
      window.location.href = "/" + localStorage.getItem("role") + '/othercertificationstatus/' + this.state.data._id;
   }
    
    render() {

        // if (this.state.isLoading) {
        //     return (<h1>Loading</h1>)
        // }
        return (
            <div>
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card-body" style={{ paddingLeft: "50px" }}>

                                        <div className="row">

                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Client Name</label>
                                            <div className="col-sm-9">
                                                <p>{this.state.data.orgName}</p>

                                            </div>
                                        </div>
                                        <div className="row mt-4">

                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Scope</label>
                                            <div className="col-sm-9">
                                                <p>{this.state.data.scope}</p>

                                            </div>
                                        </div>


                                        <div className="row mt-4">
                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Company Address</label>
                                            <div className="col-sm-9">
                                                <p>{this.state.data.address}</p>

                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Certificate No</label>
                                            <div className="col-sm-3">
                                                <p>{this.state.data.certificateno}</p>
                                            </div>

                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Type of Certification</label>
                                            <div className="col-sm-3">
                                                <p>{this.state.data.typeOfCertification}</p>
                                            </div>
                                        </div>

                                        <div className="row mt-4">
                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Original Registered Date</label>
                                            <div className="col-sm-3">
                                                <p>{moment(this.state.data.dateofissue).format('DD-MM-YYYY')}</p>
                                            </div>

                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Current Issue Date</label>
                                            <div className="col-sm-3">
                                                <p>{moment(this.state.data.initialcertdate).format('DD-MM-YYYY')}</p>
                                            </div>
                                        </div>

                                        <div className="row mt-4">
                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Expiry Date</label>
                                            <div className="col-sm-3">
                                            <p>{moment(this.state.data.expirydate).format('DD-MM-YYYY')}</p>
                                            </div>

                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Status</label>
                                            <div className="col-sm-3">
                                                <p>{this.state.data.status}</p>
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Audit Type</label>
                                            <div className="col-sm-3">
                                                <p>{this.state.data.certstatusvalue}</p>
                                            </div>

                                            
                                        </div>
                                        <div className="row mt-4">
                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Annenxure</label>
                                            <div className="col-sm-9">
                                            <p>{this.state.data.annenxure}</p>
                                            {/* <p dangerouslySetInnerHTML={{ __html:this.state.data.annenxure}}></p> */}
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>

                        </div>

                    </section>
                </div>
                <div className="card-footer">
                    <div className="row">

                        <div className="col-sm-10"></div>
                        <div className="col-sm-2">

                            <button type="submit" className="btn btn-primary float-right" onClick={() => this.handleRoute()}>Edit</button>

                        </div>

                    </div>
                </div>
            </div>

        )
    }

}
